import { useWSModal } from "@wingspanhq/fe-component-library";
import { PayoutsBetaModal } from ".";

export const usePayoutsBetaModal = () =>
  useWSModal(PayoutsBetaModal, {
    title: "Introducing the Payouts (Beta) feature",
    size: "M"
  });
